export const removeDiacritics = (value: string): string =>
  value.normalize('NFKD').replace(/\p{M}/gu, '');
